import React from "react";

const SVGComponent = (props) => {
  return (
    <svg
      className="pencil-icon"
      xmlns="http://www.w3.org/2000/svg"
      width={props.height || "15"}
      height={props.height || "13"}
    >
      <path
        fill={props.fill || "#6C6C6C"}
        transform="translate(0.0367889 0)"
        d="M12.523896 1.4284766L11.571498 0.47607422C11.254371 0.15869141 10.838474 0 10.422577 0C10.00668 0 9.5907841 0.15869141 9.2734022 0.4758203L0.32629344 9.4229689L0.0038339221 12.323086C-0.0367909 12.688203 0.25088361 13 0.60812813 13C0.63072568 13 0.65332323 12.998731 0.67642862 12.996191L3.5745018 12.676016L12.52415 3.7263281C13.158659 3.0918164 13.158659 2.0629883 12.523896 1.4284766ZM3.2015152 11.900078L0.8394357 12.161856L1.1024815 9.7962112L7.802784 3.0958788L9.904357 5.1974611L3.2015152 11.900078ZM11.949563 3.1519921L10.47869 4.6228709L8.3771172 2.5212891L9.84799 1.0504102C10.001348 0.8970508 10.205488 0.8125 10.422577 0.8125C10.639667 0.8125 10.843552 0.8970508 10.997165 1.0504102L11.949563 2.0028124C12.266182 2.3196876 12.266182 2.8351171 11.949563 3.1519921Z"
      />
    </svg>
  );
};

export default SVGComponent;
